<script>
    import Vue from 'vue';
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
    import MlsSettingsForm from './mls_settings_form';
    import GeneralInfoForm from './general_info_form.vue';
    import ImageSettingsForm from './image_settings_form';
    import Loader from '~/components/loader/components/loader';
    import Panel from '~/components/panel/components/panel';
    import VueButton from '~/components/button/components/button';
    import FormGroup from '~/components/form/components/form_group';

    import { Steps, Step, Select, Option, Form, FormItem, Input, Checkbox, Message } from 'element-ui';

    Vue.use(Steps);
    Vue.use(Step);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Input);
    Vue.use(Checkbox);

    export default {
        components: {
            MlsSettingsForm,
            GeneralInfoForm,
            ImageSettingsForm,
            Loader,
            Panel,
            VueButton,
            FormGroup
        },

        data() {
            return {
                isLoading: false
            }
        },

        computed: {
            ...mapState('newUserRegistrationForm', {
                mlsSettingsFormShowing: state => state.mlsSettingsForm.formShowing,
                generalInfoFormShowing: state => state.generalInfoForm.formShowing,
                imageSettingsFormShowing: state => state.imageSettingsForm.formShowing,
                stepActive: state => state.stepActive

            })
        },

        created() {
            this.updateFormShowingStatus({
                formName: 'mlsSettingsForm',
                showingStatus: true
            });
        },

        methods: {
            ...mapMutations('newUserRegistrationForm', {
                updateFormShowingStatus: 'updateFormShowingStatus'
            })
        }
    }
</script>
<template>
    <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeInDown"
    >
        <div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="top-spacer">
                    </div>
                </div>
                <div class="col-xs-8 col-xs-offset-2 col-md-6 col-md-offset-3">
                    <el-steps
                        :active="stepActive"
                        :align-center="true"
                        :center="true"
                    >
                        <el-step title="MLS Information"></el-step>
                        <el-step title="General Info"></el-step>
                        <el-step title="Images"></el-step>
                    </el-steps>
                </div>
                <div class="col-xs-12">
                    <div class="bottom-spacer">
                    </div>
                </div>
            </div>
            <div class="row">
                 <div class="col-xs-12 col-md-12">
                     <template v-if="mlsSettingsFormShowing">
                         <mls-settings-form></mls-settings-form>
                     </template>
                     <template v-if="generalInfoFormShowing">
                         <general-info-form></general-info-form>
                     </template>
                    <template v-if="imageSettingsFormShowing">
                       <image-settings-form></image-settings-form>
                    </template>
                </div>
            </div>
        </div>
    </transition>
</template>
<style scoped>
    .top-spacer {
        width: 100%;
        height: 100px;
    }

    .bottom-spacer {
        width: 100%;
        height: 30px;
    }
</style>